import classNames from 'classnames';
import dayjs from 'dayjs';
import { Link } from 'modules/i18n';
import useUser from 'modules/User/hooks/useUser';
import React from 'react';
import { User } from '../interfaces';
import { RatingDisplay } from 'modules/rating/components/RatingDisplay';

type UserStatsProps = React.HTMLAttributes<HTMLDivElement> & {
  user: User;
};

const UserStats: React.FC<UserStatsProps> = ({ children, className, user, ...props }) => {
  const {
    name,
    createdAt,
    nbSearchedProfiles,
    nbAvailableProfiles,
    nbSearchedProfilesPublished,
    nbAvailableProfilesPublished,
    nbContactsSourcing,
    nbQualityContactsSourcing,
    nbContactsProspecting,
    lastLoginAt,
    nbQualityContactsProspecting,
    rating,
  } = user;

  const { hasPermission } = useUser();
  return (
    <div className={classNames('text-xs min-w-[240px]', className)} {...props}>
      <div className="flex items-center gap-2">
        <span>
          Membre depuis{' '}
          <span className="badge badge-xs text-xs gap-1">
            <strong>{dayjs(createdAt).fromNow().replace('il y a', '')}</strong>
          </span>
        </span>
        {rating && rating.count > 0 && (
          <div className="flex items-center gap-1">
            <RatingDisplay user={user} size="sm" showLabel />
            <span className="text-gray-500">({rating.count} avis)</span>
          </div>
        )}
      </div>
      {false && nbSearchedProfiles === 0 && nbAvailableProfiles === 0 && nbContactsSourcing === 0 && nbContactsProspecting === 0 ? (
        <div>
          <span className="my-3 badge !border-error !text-error border-dashed !bg-white">Inactif</span>
        </div>
      ) : (
        <ul className="!list-none pl-2 mt-1">
          <li>
            💼{' '}
            {nbSearchedProfilesPublished > 0 ? (
              <Link className="link" href={`/searched-profiles?q=${name}`}>
                {' '}
                Missions actives
              </Link>
            ) : (
              'Missions actives'
            )}
            : <strong>{nbSearchedProfilesPublished}</strong> (total: {nbSearchedProfiles})
          </li>
          <li>
            🙋{' '}
            {nbSearchedProfilesPublished > 0 ? (
              <Link className="link" href={`/available-profiles?q=${name}`}>
                {' '}
                Candidats Off-Market
              </Link>
            ) : (
              'Candidats Off-Market'
            )}
            : <strong>{nbAvailableProfilesPublished}</strong> (total: {nbAvailableProfiles})
          </li>
          {hasPermission('superadmin') && (
            <li>
              📩 Prospection dans la cible: <strong>{nbQualityContactsProspecting}</strong> / {nbContactsProspecting}
            </li>
          )}
          <li>
            📤 Sourcing dans la cible: <strong>{nbQualityContactsSourcing}</strong> / {nbContactsSourcing}
          </li>
        </ul>
      )}
      <div className="text-xs text-[#999] mt-1 ml-2">
        Dernière connexion:{' '}
        <span className="italic" suppressHydrationWarning>
          {dayjs(lastLoginAt).fromNow()}
        </span>
      </div>
    </div>
  );
};

export default UserStats;
